/** Typewriter mode (#68): how far paragraphs away from the caret dim. */

/** Opacity for a block `distance` paragraphs away from the caret's block. */
const DIM_NEAREST = 0.55;
const DIM_FLOOR = 0.15;
const DIM_STEP = 0.2;

export function dimOpacityForDistance(distance: number): number {
  if (distance <= 0) return 1;
  return Math.max(DIM_FLOOR, DIM_NEAREST - (distance - 1) * DIM_STEP);
}
